import { DashboardWalletSummary, HomeCard, percentageFormatter, shortLabelForWalletMacroCategoryType } from 'azshared';
import React, { useCallback, useMemo, useRef } from 'react';
import { useIntl } from 'react-intl';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { AppSvgIcon } from '../../../../../components/svg-icon/app-svg-icon';
import './home-my-wallet-card.scss';

interface HomeMyWalletCardCarouselProps {
  card: HomeCard<DashboardWalletSummary>;
}

const cardSize = 90;
const cardGap = 20;

export const HomeMyWalletCardCarousel = (props: HomeMyWalletCardCarouselProps) => {
  const { formatMessage } = useIntl();
  const { card } = props;
  const sliderRef = useRef<Slider>(null);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true
  };

  const buttonStyle: React.CSSProperties = {
    border: 'none',
    borderRadius: '50%',
    height: '24px',
    width: '24px',
    backgroundColor: '#FFFFFF',
    boxShadow: '4px 4px 12px rgba(0, 0, 0, 0.1)',
    position: 'relative',
    padding: 0,
    cursor: 'pointer'
  };

  const iconStyle: React.CSSProperties = {
    height: '11px',
    width: '7px',
    position: 'absolute',
    top: '50%',
    left: '50%'
  };

  const filteredCategories = useMemo(() => {
    if (!card.value?.macroCategories) return [];
    
    return card.value.macroCategories.filter(
      (category) => 
        category.amount.value > 0 && 
        category.type !== 'TotalFia' && 
        category.type !== 'TotalPortfolio'
    );
  }, [card.value?.macroCategories]);

  // A simple check if there are enough slides to warrant showing buttons.
  // This is an approximation. A better way would be to measure the container,
  // but we removed that to avoid conflicts. Let's assume more than 4 slides need buttons.
  const showButtons = filteredCategories.length > 4;

  const handlePrev = useCallback(() => sliderRef.current?.slickPrev(), [sliderRef]);
  const handleNext = useCallback(() => sliderRef.current?.slickNext(), [sliderRef]);

  return (
    <div className='home-wallet-card-carousel' style={{ minWidth: 0 }}>
      <Slider ref={sliderRef} {...settings}>
        {filteredCategories.map((item) => (
          <div key={item.type} style={{ width: cardSize, marginRight: cardGap }}>
            <div className='macrocategory-carousel'>
              <div className='macrocategory-carousel-percentage'>
                {percentageFormatter(item.percentage || 0, { significantDigits: item.percentage ? 2 : 0, isPercentage: true })}
              </div>
              <div className='macrocategory-carousel-label'>{formatMessage(shortLabelForWalletMacroCategoryType(item.type))}</div>
              <div className='macrocategory-carousel-dot' style={{ backgroundColor: item.color }}></div>
            </div>
          </div>
        ))}
      </Slider>
      {showButtons && (
        <div className='home-wallet-card-arrow-buttons'>
          <button style={buttonStyle} onClick={handlePrev}>
            <span style={{ ...iconStyle, transform: 'translate(-60%, -50%)' }}>
              <AppSvgIcon icon={'arrow-left'} />
            </span>
          </button>
          <button style={buttonStyle} onClick={handleNext}>
            <span style={{ ...iconStyle, transform: 'translate(-30%, -50%)' }}>
              <AppSvgIcon icon={'arrow-right'} />
            </span>
          </button>
        </div>
      )}
    </div>
  );
};